import { cn } from "@/lib/utils";

/** The floating white container that gives the page its rhythm. */
export const SurfaceCard = ({ as: Tag = "section", pad = true, hover = false, className, children, ...rest }) => (
  <Tag
    className={cn("ps-card", pad && "ps-card-pad", hover && "ps-card-hover", className)}
    {...rest}
  >
    {children}
  </Tag>
);
